import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MostPopularCourses from "./../../../assets/images/profileImage.jpg";
import { MdOutlineLocationOn } from "react-icons/md";
import { Button } from "@mui/material";
import {
  MostPopularCoursesNavbar,
  BackHeader,
  SideMenu,
} from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let UpcommingEvents = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let CardData = [
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
  ];
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Upcomming Events</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <Button
                        className="card-button-main"
                        onClick={() => {
                          navigate("/upcomming-events/details", {
                            state: { type: location.state.type },
                          });
                        }}
                      >
                        <img src={MostPopularCourses} className="card-image" />
                        <p className="card-heading">
                          Lorem ipsum dolor sit a...
                        </p>
                        <div className="card-bottom-main">
                          <div className="card-location-main">
                            <MdOutlineLocationOn color="#663399" />

                            <p className="card-location">burnside</p>
                          </div>
                          <p className="card-upcomming-event-price">$2000</p>
                        </div>
                        <div className="card-bottom-main">
                          <p className="card-upcomming-event-date">
                            14 march 2022,
                          </p>
                          <p className="card-upcomming-event-date">
                            19 march 2022,
                          </p>
                        </div>
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Upcomming Events</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <Button
                        className="card-button-main"
                        onClick={() => {
                          navigate("/upcomming-events/details", {
                            state: { type: location.state.type },
                          });
                        }}
                      >
                        <img src={MostPopularCourses} className="card-image" />
                        <p className="card-heading">
                          Lorem ipsum dolor sit a...
                        </p>
                        <div className="card-bottom-main">
                          <div className="card-location-main">
                            <MdOutlineLocationOn color="#663399" />

                            <p className="card-location">burnside</p>
                          </div>
                          <p className="card-upcomming-event-price">$2000</p>
                        </div>
                        <div className="card-bottom-main">
                          <p className="card-upcomming-event-date">
                            14 march 2022,
                          </p>
                          <p className="card-upcomming-event-date">
                            19 march 2022,
                          </p>
                        </div>
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </SideMenu>
      )}
    </div>
  );
};
export default UpcommingEvents;
